/**
 * IAM 共享常量（前端使用）
 *
 * 与后端 backend/src/common/utils/role-check.util.ts 保持值同步：
 * 这两份文件不能跨目录 import，只能各自维护字面量；任何改动需双边同步。
 */

/** 系统级 admin 权限码（高于一切 controller-specific 权限的 OR fallback）。 */
export const SYSTEM_ADMIN_PERMISSION = 'system:admin';

/** 系统级 Administrator role code。 */
export const ADMINISTRATOR_ROLE_CODE = 'Administrator';
